import {useEffect, useState} from 'react';
import {calendar, type CalendarDayEntry as FitnessDay} from '../services/api';
import {localToday, shiftDay} from '../utils/fitnessProgress';

export function useFitnessRamp(athleteId?: number | null, refreshKey?: unknown) {
  const today = localToday();
  const [retry, setRetry] = useState(0);
  const [state, setState] = useState<{id: number; today: string; refreshKey: unknown; retry: number; days: FitnessDay[]; error: boolean} | null>(null);
  useEffect(() => {
    if (!athleteId) return;
    let active = true;
    void calendar.getCalendarData(athleteId, shiftDay(today, -35), today).then(response => {
      const rows = response?.data?.data ?? response?.data;
      if (!Array.isArray(rows)) throw new Error('Invalid fitness history');
      if (active) setState({id: athleteId, today, refreshKey, retry, days: rows, error: false});
    }).catch(() => {
      if (active) setState({id: athleteId, today, refreshKey, retry, days: [], error: true});
    });
    return () => {active = false;};
  }, [athleteId, today, refreshKey, retry]);
  const current = state?.id === athleteId && state?.today === today && state?.refreshKey === refreshKey && state?.retry === retry ? state : null;
  return {days: current?.days ?? [], today, error: current?.error ?? false, loading: !!athleteId && !current, retry: () => setRetry(value => value + 1)};
}
